<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <a-form-item label="组件类型">
        <a-select
          :value="config.type"
          placeholder="选择搜索组件"
          show-search
          option-filter-prop="label"
          :options="typeOptions"
          @change="onTypeChange"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item label="名称">
        <a-input
          v-model:value="config.label"
          allow-clear
          :placeholder="record?.title || '默认=列中文名'"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item label="可清空">
        <a-switch
          v-model:checked="config.allowClear"
          checked-children="开"
          un-checked-children="关"
          :disabled="!config.type"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item label="禁用">
        <a-switch
          v-model:checked="config.disabled"
          checked-children="开"
          un-checked-children="关"
          :disabled="!config.type"
        />
      </a-form-item>
    </a-col>
    <a-col
      v-if="isRangeType"
      :span="24"
    >
      <a-form-item label="提示语">
        <a-space-compact
          block
          style="width: 100%"
        >
          <a-input
            v-model:value="config.placeholder[0]"
            placeholder="开始"
            :style="{ width: '50%' }"
          />
          <a-input
            v-model:value="config.placeholder[1]"
            placeholder="结束"
            :style="{ width: '50%' }"
          />
        </a-space-compact>
      </a-form-item>
    </a-col>
    <a-col
      v-else
      :span="24"
    >
      <a-form-item label="提示语">
        <a-input
          v-model:value="config.placeholder"
          allow-clear
          :disabled="!config.type"
        />
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
/* 基础属性（所有组件类型共享）：类型选择 + label + 可清空/禁用 + placeholder（区间类型双输入）。
   类型切换交给父组件处理（需要合并类型默认值）。 */
import { computed } from 'vue';
import { RANGE_PLACEHOLDER_TYPES, typeOptions } from './constants';

const props = defineProps<{
  config: any;
  record: any; // 列配置行（取列中文名作 label 默认值）
}>();
const emit = defineEmits<{ (e: 'type-change', type: string): void }>();

const isRangeType = computed(() => RANGE_PLACEHOLDER_TYPES.includes(props.config?.type));
const onTypeChange = (type: any) => emit('type-change', type);
</script>
